module.exports = __webpack_public_path__ + "./images/13b4d99d35f429e88c9f86848e5216fb.webp";